export function toFixedNumber(number: string | number, fractionDigits: number) {
    return Number(Number(number).toFixed(fractionDigits));
}

export function toFixedAccuracy(number: string | number, fractionDigits: number) {
    const decimalDigits = accuracyCal(fractionDigits);
    return Number(Number(number).toFixed(decimalDigits));
}

export function accuracyCal(value: number): number {
    var pointPosition = String(value).indexOf('.') + 1;
    var decimalDigits = String(value).length - pointPosition;
    return decimalDigits;
}

export function decimalCount(value: number) {
    if (Math.floor(value) === value) {
        return 0;
    }

    return value.toString().split('.')[1].length || 0;
}
